import * as AV from "./Interfaces/AV.Interfaces";
import { Server } from "../Platform/Server";

export class Plan {
  static _planApi = "/api/Plan";

  public static async payments(fk: AV.IFK): Promise<AV.ICollectLog[]> {
    return await Server.post(`${this._planApi}/Payments`, fk);
  }

  public static async getTransactions(
    fk: AV.IFK,
  ): Promise<AV.ICreditTransaction[]> {
    return await Server.post(`${this._planApi}/GetTransactions`, fk);
  }

  public static async sharePlan(
    param: AV.IPlanNewParam,
  ): Promise<AV.ISharedPlan> {
    return await Server.post(`${this._planApi}/SharePlan`, param);
  }

  public static async stopShare(param: AV.IFK): Promise<AV.IAVEntity> {
    return await Server.post(`${this._planApi}/StopShare`, param);
  }

  public static async shareWith(
    param: AV.IPlanShareParam,
  ): Promise<AV.ISharedPlan> {
    return await Server.post(`${this._planApi}/ShareWith`, param);
  }

  public static async unshare(
    param: AV.ITypeLinkListParam,
  ): Promise<AV.ISharedPlan> {
    return await Server.post(`${this._planApi}/Unshare`, param);
  }

  public static async save(plan: AV.ISharedPlan): Promise<AV.ISharedPlan> {
    return await Server.post(`${this._planApi}/Save`, plan);
  }
}
